import { mountTrackingWidget } from "@shipitfi/tracking-widget";

window.mountTrackingWidget = mountTrackingWidget;
